"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcResourceStatusCard = class UcResourceStatusCard extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    resource;
    onResource(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resource");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_emit_2548_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_3343864469950044_request_2546_getActionArgs($event) {
        return {
            url: this.resource.links.self,
            method: "patch",
            data: {
                etag: this.resource.etag,
                inactive: !this.resource.inactive,
            },
        };
    }
    async evh_3343864469950044_clickStopPrevent(event, scope) {
        return await this.actions.evh_3343864469950044_clickStopPrevent.executeFromDOM(this, event, scope);
    }
    async act_1889980785424776_emit_2552_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_1889980785424776_request_2550_getActionArgs($event) {
        return {
            url: this.resource.links.self,
            method: "patch",
            data: {
                etag: this.resource.etag,
                inactive: !this.resource.inactive,
            },
        };
    }
    async evh_1889980785424776_clickStopPrevent(event, scope) {
        return await this.actions.evh_1889980785424776_clickStopPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2544 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2543 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2544,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2543],
        });
        const act_3343864469950044_emit_2548 = new core_1.actions.EmitAction({
            actionArgs: this.act_3343864469950044_emit_2548_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_success_2547 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_emit_2548,
            event: "success",
            displayName: "emit",
        });
        const act_3343864469950044_request_2546 = new core_1.actions.RequestAction({
            actionArgs: this.act_3343864469950044_request_2546_getActionArgs,
            displayName: "toggleState",
            events: [evh_3343864469950044_success_2547],
        });
        const evh_3343864469950044_clickStopPrevent_2545 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_request_2546,
            event: "click.stop.prevent",
            displayName: "toggleState",
        });
        const evh_3343864469950044_clickStopPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_clickStopPrevent_2545],
        });
        const act_1889980785424776_emit_2552 = new core_1.actions.EmitAction({
            actionArgs: this.act_1889980785424776_emit_2552_getActionArgs,
            events: [],
        });
        const evh_1889980785424776_success_2551 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_emit_2552,
            event: "success",
            displayName: "emit",
        });
        const act_1889980785424776_request_2550 = new core_1.actions.RequestAction({
            actionArgs: this.act_1889980785424776_request_2550_getActionArgs,
            displayName: "toggleState",
            events: [evh_1889980785424776_success_2551],
        });
        const evh_1889980785424776_clickStopPrevent_2549 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_request_2550,
            event: "click.stop.prevent",
            displayName: "toggleState",
        });
        const evh_1889980785424776_clickStopPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1889980785424776_clickStopPrevent_2549],
        });
        return {
            act_7315092382398562_reloadComponentData_2544,
            evh_7315092382398562_reload_2543,
            evh_7315092382398562_reload,
            act_3343864469950044_emit_2548,
            evh_3343864469950044_success_2547,
            act_3343864469950044_request_2546,
            evh_3343864469950044_clickStopPrevent_2545,
            evh_3343864469950044_clickStopPrevent,
            act_1889980785424776_emit_2552,
            evh_1889980785424776_success_2551,
            act_1889980785424776_request_2550,
            evh_1889980785424776_clickStopPrevent_2549,
            evh_1889980785424776_clickStopPrevent,
            toggleState: act_1889980785424776_request_2550,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcResourceStatusCard.prototype, "resource", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resource'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcResourceStatusCard.prototype, "onResource", null);
UcResourceStatusCard = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcResourceStatusCard);
exports.default = UcResourceStatusCard;
vue_property_decorator_1.Vue.component("UcResourceStatusCard", UcResourceStatusCard);
